import { motion } from "framer-motion";

const variants = {
  hidden: { opacity: 0, y: 22, filter: "blur(8px)" },
  visible: { opacity: 1, y: 0, filter: "blur(0px)" },
};

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      variants={variants}
    >
      {children}
    </MotionTag>
  );
};

export const RevealStagger = ({ children, className = "", stagger = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-60px" }}
    transition={{ staggerChildren: stagger }}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className = "", ...rest }) => (
  <motion.div className={className} variants={variants} transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }} {...rest}>
    {children}
  </motion.div>
);
